'use strict';

var reactIs_production = {};

exports.__exports = reactIs_production;
//# sourceMappingURL=react-is.production.cjs.map
